import {GlobalVariables} from "../GlobalVariables";
export default class ArchiveCaseStudies {
	static init() {

		let swiperElement = document.querySelector(".swiper-case-highlighted");
		if( !swiperElement ){
			return;
		}

		new Swiper(swiperElement, {
			centeredSlides: true,
			slidesPerView: 1,
			spaceBetween: 40,
			speed: 800,
			loop: true
		});

	}

}
